import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'

export default {
  addMediaToNominationPost: function (mediaID, postID) {
    var sendNomination = {
      method: 'POST',
      data: {
        substantiation_documentation: mediaID
      },
      headers: {
        'Authorization': localStorage.getItem('userToken'),
        'Content-Type': 'application/json'
      },
      json: true
    }
    WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination/' + postID)
      .then(function (response) {
        console.log(response)
      })
      .catch(function (e) {
        console.error(e)
      })
  },
  uploadSupportingDocumentation: function (postID, supportingDoc, validatedNominee) {
    var self = this
    var formData = new FormData()
    formData.append('file', supportingDoc)
    formData.append('title', 'Supporting documentation for ' + validatedNominee)
    formData.append('caption', 'Supporting documentation for ' + validatedNominee)
    var uploadMedia = {
      method: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      headers: {
        'Authorization': localStorage.getItem('userToken'),
        'Content-Type': 'application/json'
      },
      json: true
    }
    WordpressRestAPI.endpointWithAuthetication(uploadMedia, 'media')
      .then(function (response) {
        console.log(response)
        self.addMediaToNominationPost(response.data.id, postID)
      })
      .catch(function (e) {
        console.error(e)
      })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/SupportingDocumentation.js